module.exports = __webpack_public_path__ + "static/media/Issued-Order-of-Justice-Kimmel-06-JUN-2025 - Oxford Road Dev.1595da36.pdf";